<template>
    <el-dialog
            :visible.sync="showMsgForm.showMsg"
            width="750px"
            height="75%"
            :show-close="false"
            :before-close="handleClose"
            class="a_modal"
            style="vertical-align: center;: #FFF9F3">
        <div style="margin-top: -30px; ">

            <el-row>
                <el-col :span="12">
                    <span v-if="showMsgForm.type === 'SERVICE'" style="color: cornflowerblue; font-size: 18px">与服务人员的沟通</span>
                    <span v-else-if="showMsgForm.type === 'RETAIL'" style="color: cornflowerblue; font-size: 18px">与门店的沟通</span>
                </el-col>
                <el-col :span="12">
                    <div align="right" style="margin-top: -5px">
                        <el-row>
                            <el-button type="success" size="small"
                                       @click.stop="saveMsg">保存
                            </el-button>
                            <el-button type="danger" size="small"
                                       @click.stop="showMsgForm.showMsg=false">取消
                            </el-button>
                        </el-row>
                    </div>
                </el-col>
            </el-row>

            <div style="width: 100%; height: 0px; margin-top: 15px;border:1px dashed gainsboro"></div>

            <div style="margin-top: 20px">
                <el-form ref="form4" :model="showMsgForm" label-width="10%">

                    <el-form-item label="内容">
                        <el-input
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 10}"
                                placeholder="请输入内容"
                                v-model="showMsgForm.msg">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="上传照片">
                        <el-upload
                                action="https://api.retailstore365.com:15041/uploadphoto"
                                :http-request="uploadSendFun"
                                list-type="picture-card"
                                :show-file-list="true" multiple
                                :on-preview="handlePictureCardPreview"
                                :on-success="handleImgSuccess"
                                :before-upload="beforeSendImgUpload"
                                :on-remove="handleSendRemove"
                                :file-list="showMsgForm.fileList">
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </el-dialog>

</template>

<script>
    import http from '../../../APIService/http'

    export default {
        props: {
        },
        components: {},
        data() {
            return {

                showMsgForm : {
                    showMsg: false,
                    msg: "",
                    type: "",
                    photos: [],
                    fileList: []
                },
            }
        },
        computed: {},
        created() {

        },
        methods: {

            getInfo(data){
                this.showMsgForm = data
            },
            handleClose(done) {
                done();
            },

            async uploadSendFun(param) {
                var user = this.$store.getters.getUser

                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', user.reference_obj);
                data.append('reference_id', user.reference_id);
                data.append('credential', user.client_secret);
                data.append('username', user.username);
                data.append('tenant_id', user.tenant_id);
                data.append('user_id', user.user_id);
                data.append('category', 'USER');
                data.append('size', '300');

                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头

                let res = await http.post(param.action, data)
                if (res.success) {
                    var s3filename = res.data.s3filename
                    var obj = this.showMsgForm.photos[this.showMsgForm.photos.length-1]
                    obj.file_id = s3filename
                }
            },
            handlePictureCardPreview(file) {
                this.$emit('showImageAction', {
                    showImageUrl: file.url,
                    showImage: true
                })
            },
            handleImgSuccess(res, file) {

            },
            // 上传图片前的验证
            beforeSendImgUpload(file) {

                const isPic = file.type === 'application/x-jpg' || file.type === 'image/jpeg' || file.type === 'application/x-png' || file.type === 'image/png'
                if (!isPic) {
                    this.error('上传图片只能是 jpg 或png 格式!')
                }
                else {
                    this.showMsgForm.photos.push({uid : file.uid, file_id : ''})
                }

                return isPic
            },
            handleSendRemove(file, fileList) {

                console.log(file, fileList);
                for (var i = 0; i < this.showMsgForm.photos.length; i++){
                    var obj = this.showMsgForm.photos[i]
                    if (obj.uid == file.uid){
                        this.showMsgForm.photos.splice(i,1)
                        return
                    }
                }
            },
            saveMsg(){
                if (this.showMsgForm.msg.replace(/\s*/g, "") == "") {
                    this.$message.error('请输入内容');
                    return
                }
                this.$emit('saveMsg', this.showMsgForm)
            }
        }
    }
</script>

<style lang="scss" module>
    @import '../../../assets/css/default';


</style>
<style scoped>

    .subjectList > > > .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/dialog/addMessage.vue